<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: team-svg.vue
  - Created by: ChanYing
  - Create Date: 2023-05-11 17:11
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9 11.25C10.3807 11.25 11.5 10.1307 11.5 8.75C11.5 7.36929 10.3807 6.25 9 6.25C7.61929 6.25 6.5 7.36929 6.5 8.75C6.5 10.1307 7.61929 11.25 9 11.25Z"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M13.25 7.25001C13.8323 7.24903 14.4069 7.38415 14.9277 7.64458C15.4486 7.90501 15.9014 8.28355 16.25 8.75001"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.75 8.75001C2.09862 8.28355 2.55142 7.90501 3.07229 7.64458C3.59315 7.38415 4.16766 7.24903 4.75 7.25001"
          :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M5.3999 13.5C5.72917 12.8257 6.2412 12.2574 6.87768 11.8599C7.51416 11.4624 8.24949 11.2516 8.9999 11.2516C9.75032 11.2516 10.4856 11.4624 11.1221 11.8599C11.7586 12.2574 12.2706 12.8257 12.5999 13.5"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M4.75008 7.25C4.37048 7.25038 3.99861 7.14273 3.67792 6.93962C3.35723 6.73651 3.10097 6.44633 2.93907 6.10299C2.77717 5.75965 2.71633 5.37732 2.76365 5.00068C2.81097 4.62404 2.9645 4.26865 3.2063 3.97603C3.4481 3.6834 3.76818 3.46564 4.12915 3.34817C4.49011 3.2307 4.87705 3.21839 5.24476 3.31266C5.61247 3.40694 5.94575 3.60391 6.20567 3.88057C6.46558 4.15722 6.6414 4.50213 6.71258 4.875"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path
        d="M11.2876 4.875C11.3588 4.50213 11.5346 4.15722 11.7945 3.88057C12.0544 3.60391 12.3877 3.40694 12.7554 3.31266C13.1231 3.21839 13.5101 3.2307 13.871 3.34817C14.232 3.46564 14.5521 3.6834 14.7939 3.97603C15.0357 4.26865 15.1892 4.62404 15.2365 5.00068C15.2838 5.37732 15.223 5.75965 15.0611 6.10299C14.8992 6.44633 14.6429 6.73651 14.3223 6.93962C14.0016 7.14273 13.6297 7.25038 13.2501 7.25"
        :stroke="strokeColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'team-svg',
  props: {
    strokeColor: {
      type: String,
      default: "var(--body-aux-1)"
    }
  },
};
</script>
